export const UPDATE_UI = 'UPDATE_UI';
export const SET_DM_SIDEBAR_OPEN = 'SET_DM_SIDEBAR_OPEN';

export const updateUI = (id, uiRect) => {
  return {
    type: UPDATE_UI,
    payload: { id, uiRect },
  };
};

export const setDMSidebarOpen = (isOpen) => {
  return {
    type: SET_DM_SIDEBAR_OPEN,
    payload: { isOpen },
  };
};
